import { Component, OnInit } from '@angular/core';
import { appNotificationText } from '../models/appNotificationText';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrManager } from 'ng6-toastr-notifications';
import { TableUtil } from '../tableUtil';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-appnotificationtextmanagement',
  templateUrl: './appnotificationtextmanagement.component.html',
  styleUrls: ['./appnotificationtextmanagement.component.css']
})
export class AppnotificationtextmanagementComponent implements OnInit {
  @ViewChild(MatSort,{static:true}) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("appNotificationText") form: any;
  @ViewChild("appNotificationTextUpdate", {static: true}) formUpdate: any;
  appNotificationTextUpdateObj:appNotificationText
  editor = ClassicEditor;

  appNotificationTextAddObj:appNotificationText
  show:boolean=false
  dataSource:any;
  displayedColumns = [ 'notificationType', 'notificationTitle','notificationTextDescription' ,'status','Action']
  userDetails:any;
  userSessionData:any
  read:any;
  write:any;
  delete:any
  constructor( private cs:CucurachaAdminService,private toastr: ToastrManager) { 
    this.appNotificationTextAddObj= new appNotificationText();
    this.appNotificationTextUpdateObj= new appNotificationText();

  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  addAppNotificationText(){
    if(this.show==false){
      this.show=true
      this.form.reset();
      this.formUpdate.reset()
    }
    else{
      this.show=false
      this.form.reset();
      this.formUpdate.reset()

    }
  }
  saveAppNotificationTexts(){
    this.cs.saveAppNotificationTexts(this.appNotificationTextAddObj).subscribe((data) => {
   

        if(data.result ){
          this.getAllappNotificationTexts();
          this.toastr.successToastr(data.message);
          this.form.reset();
          
          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
    
         }
          else{
            this.toastr.errorToastr(data.message);
    
          }
   
  });
}
  getAllappNotificationTexts(){
    this.cs.getAllappNotificationTexts().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
  }
  getByAppNotificationTextId(id:any){
    this.cs.getByAppNotificationTextId(id).subscribe((data) => {
      this.appNotificationTextUpdateObj._id=data[0]._id;
  
      this.appNotificationTextUpdateObj.notificationType=data[0].notificationType
      this.appNotificationTextUpdateObj.notificationTitle=data[0].notificationTitle
      this.appNotificationTextUpdateObj.notificationTextDescription=data[0].notificationTextDescription
      
    })
  }
  onChange(status, id) {
    this.cs.getByAppNotificationTextId(id).subscribe((data) => {
      this.appNotificationTextUpdateObj._id=data[0]._id;
  
      this.appNotificationTextUpdateObj.notificationType=data[0].notificationType
      this.appNotificationTextUpdateObj.notificationTitle=data[0].notificationTitle
      this.appNotificationTextUpdateObj.notificationTextDescription=data[0].notificationTextDescription

      this.appNotificationTextUpdateObj.status = status.checked;

      this.cs.updateAppNotificationTextstatus(this.appNotificationTextUpdateObj).subscribe((data) => {
        if(data.result ){
          this.ngOnInit();
          this.toastr.successToastr(data.message);
          this.form.reset();
          
          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
          this.ngOnInit();

         }
          else{
            this.toastr.errorToastr(data.message);
            this.ngOnInit();

          }
      })
    })
  }
  updateAppNotificationText(){
    this.cs.updateAppNotificationText(this.appNotificationTextUpdateObj).subscribe((data) => {
    
      if(data.result ){
        this.getAllappNotificationTexts();
        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();
        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
    })
  }
  deleteAppNotificationText(id:any){
    this.cs.deleteAppNotificationText(id).subscribe((data) => {
      this.getAllappNotificationTexts()
      this.toastr.warningToastr("Data  Deleted");
    })

  }
  ngOnInit(): void {
    this.getAllappNotificationTexts();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails=data[0]
      this.read=(this.userDetails.roledetails[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].read);
      this.write=(this.userDetails.roledetails[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].write)
      this.delete=(this.userDetails.roledetails[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].delete)
    })
  }

}
